module.exports = __webpack_public_path__ + "media/components/src/assets/images/news/news_12-8ce18c4b8c91223886118e88f0a2882c.jpg";